<template>
  <VSnackbar
    v-for="(massage, index) in toastStore.messages"
    :key="index"
    v-model="massage.isOpen"
    location="top"
    :width="snackbarWidth"
    timer="true"
    dir="ltr"
    :offset="index + 1"
    :timeout="4 * 1000"
    class="custom-toast elevation-0 text-white py-0 mt-8"
    :color="getToastColor(massage.toastType)"
    variant="elevated"
  >
    <template #default>
      <VRow class="position-relative">
        <VCol class="pa-0 position-absolute top-0 end-0 justify-end d-flex">
          <VBtn
            icon="close"
            variant="text"
            size="small"
            color="white"
            class="pa-0"
            @click.prevent="massage.isOpen = false"
          />
        </VCol>

        <VCol cols="auto" class="d-flex align-center ga-2 w-100 pe-6">
          <VIcon
            :size="mobile ? 32 : 45"
            color="white"
            class="flex-shrink-0"
            :icon="getToastIcon(massage.toastType)"
          />

          <div
            class="text-white min-w-0 text-break"
            style="overflow-wrap: anywhere"
          >
            <h3 class="pb-2">
              {{ getToastTitle(massage.toastType) }}
            </h3>

            <p v-for="(item, i) in massage.message" :key="i" class="mb-0">
              {{ item }}
            </p>
          </div>
        </VCol>
      </VRow>
    </template>
  </VSnackbar>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useDisplay } from 'vuetify'
import { VBtn, VCol, VIcon, VRow, VSnackbar } from 'vuetify/components'
import { ToastType } from '@/modules/Core/types/model/toast'
import { useToastStore } from '@/modules/Core/store'

const toastStore = useToastStore()
const { mobile } = useDisplay()

const snackbarWidth = computed(() =>
  mobile.value ? 'calc(100vw - 24px)' : 555
)

function getToastColor(toastType: ToastType) {
  return toastType === ToastType.Success
    ? 'success'
    : toastType === ToastType.Warning
      ? 'warning'
      : toastType === ToastType.Error
        ? 'error'
        : toastType === ToastType.Info
          ? 'info'
          : 'info'
}

function getToastIcon(toastType: ToastType) {
  return toastType === ToastType.Success
    ? 'toastSuccess'
    : toastType === ToastType.Warning
      ? 'toastWarning'
      : toastType === ToastType.Error
        ? 'toastError'
        : toastType === ToastType.Info
          ? 'toastInfo'
          : 'toastInfo'
}

function getToastTitle(toastType: ToastType) {
  return toastType === ToastType.Success
    ? 'موفقت آمیز'
    : toastType === ToastType.Warning
      ? 'اخطار'
      : toastType === ToastType.Error
        ? 'خطا'
        : toastType === ToastType.Info
          ? 'اطلاعات'
          : ''
}
</script>

<style scoped lang="scss">
.custom-toast {
  :deep(.v-snackbar__wrapper) {
    max-width: calc(100vw - 24px);
  }
}
</style>
